const vMenu = {
  props: {
    dynamicClass: ".c-v-menu.dynamicLoading",
    dropBtn: ".c-drop-btn",
    active: "mod--active",
    dropdown: ".c-dropdown",
    uncollapse: "mod--uncollapse",
    weddingCustomContactFormSelector: "js-wedding-submenu-form",
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-vMenu.css", this.props.dynamicClass);

    this.dropDownList();
    //PLASOFT-21549 added to fix the issue with the wedding submenu form
    if (document.querySelector(`.${this.props.weddingCustomContactFormSelector}`)) {
      const $weddingsCta = document.querySelectorAll(`.${this.props.weddingCustomContactFormSelector}`);
      if (!$weddingsCta) {
        return;
      }
      bcl.u.forEach($weddingsCta, ($element) => {
        this.initWeddingSubmenuFormBtn($element);
      });
    }
  },
  initWeddingSubmenuFormBtn: function ($cta) {
    if (document.documentElement.dataset.template != "bwd-page") {
      const icon = $cta.querySelector(".js-arrow");
      if (icon) {
        icon.remove();
        $cta.style.pointerEvents = "none";
        $cta.addEventListener("click", (e) => {
          e.preventDefault();
        });
      }
    } else {
      $cta.addEventListener("click", (e) => {
        e.preventDefault();
        const $modal = document.querySelector(".js-contact-modal");
        if ($modal) {
          $modal?.classList.add("mod--open");
        }
      });
    }
  },
  dropDownList: function (baseDom) {
    const baseFind = baseDom ? baseDom : document;
    const dropBtn = baseFind.querySelectorAll(this.props.dropBtn);

    if (dropBtn) {
      bcl.u.forEach(dropBtn, ($element) => {
        $element.addEventListener("click", () => {
          this.toggle($element);
        });
      });
    }
    bcl.u.resize(this.resizeDropDownList.bind(this));
  },

  toggle: function ($element) {
    bcl.u.toggleClass($element, this.props.active);

    const $dropdownElement = $element.parentNode.querySelector(this.props.dropdown);

    if ($dropdownElement) {
      let valueHeight = "";

      if (!bcl.u.containsClass($dropdownElement, this.props.uncollapse)) {
        valueHeight = $dropdownElement.scrollHeight + "px";
      }

      $dropdownElement.style.height = valueHeight;
      bcl.u.toggleClass($dropdownElement, this.props.uncollapse);
    }
  },

  resizeDropDownList: function () {
    this.resetDropDownList();
  },

  resetDropDownList: function () {
    const dropBtn = document.querySelectorAll(this.props.dropBtn);

    if (dropBtn) {
      bcl.u.forEach(dropBtn, ($element) => {
        bcl.u.removeClass($element, this.props.active);

        const $dropdownElement = $element.parentNode.querySelector(this.props.dropdown);

        if ($dropdownElement) {
          $dropdownElement.style.height = "";
          bcl.u.removeClass($dropdownElement, this.props.uncollapse);
        }
      });
    }
  },
};

export default vMenu;
